import { ResourceHelperService } from '../resource-helper.service';

/**
 * A dataservice that provides operations for usage rating rules
 */
export class UsageRatingRulesService {
  private resource: ng.resource.IResourceClass<ng.resource.IResource<InterACT.Interfaces.UsageRatingRules.UsageRatingRuleResponse | InterACT.Interfaces.UsageRatingRules.UsageRatingRulesResponse>>;

  constructor($resource: ng.resource.IResourceService, private resourceHelperService: ResourceHelperService) {
    this.resource = $resource('api/usage-rating-rules/:ruleId', undefined, { update: { method: 'PUT' } });
  }

  /**
   * A method that creates the supplied best value calculation rule via a service call
   * @param usageRatingRule the usage rating rule to be saved
   */
  public create(usageRatingRule: InterACT.Interfaces.UsageRatingRules.UsageRatingRule) {
    return this.resource.save(usageRatingRule).$promise;
  }

  /**
   * A method that updates the supplied UsageRatingRule via a service call
   * @param usageRatingRule the usageRatingRule to be updated
 */
  public update(usageRatingRule: InterACT.Interfaces.UsageRatingRules.UsageRatingRule) {
    return (<any>this.resource).update({ ruleId: usageRatingRule.id }, usageRatingRule).$promise;
  }

  /**
   * A method that deletes the supplied UsageRatingRule via a service call
   * @param usageRatingRule the usageRatingRule to be deleted
 */
  public delete(usageRatingRule: InterACT.Interfaces.UsageRatingRules.UsageRatingRule) {
    return this.resource.delete({ ruleId: usageRatingRule.id }).$promise;
  }

  /**
   * Function to retrieve a list of usage rating rules
   *
   * @param page The number of the page of data to be retrieved
   * @param perPageCount The number of items per page to be retrieved
   * @param query the query to execute against the dataset
   * @returns A http promise
   */
  public getList(page: number, perPageCount: number, query?: string) {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, query);
    return <ng.IPromise<InterACT.Interfaces.UsageRatingRules.UsageRatingRulesResponse>>this.resource.get(options).$promise;
  }
}
